<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <div>
        <div class="row">
            <div class="col-24">
                <h1 class="medium">Upload Batch Profile Updates</h1>
            </div>
        </div>
        <div class="row" *ngIf="ErrorMessage || showErrors">
            <div class="col-24">
                <div class="alert danger">
                    <p><em>Error Message:</em></p>
                    <p>There were errors with your submission, including:</p>
                    <p innerHTML="{{ErrorMessage}}"></p>
                </div>
            </div>
        </div>
        <div *ngIf="SuccessMsg">
            <div class="row">
                <div class="col-24">
                    <div class="alert success">
                        <p><em>Success Message:</em></p>
                        <p innerHTML="{{SuccessMessage}}"> </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="ifWarnings">
            <div class="col-24 alert warning">
                <p><em>Warning Message: Following license number does not match with current license in database:</em></p>
                <ul>
                    <li *ngFor="let warning of Warnings"><button>{{warning}}</button></li>
                </ul>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="alert info">
                    <ul>
                        <li class="update-info">
                            The Excel Template has been updated on 02/06/2024.
                            Please verify that you are using the latest version.
                        </li>

                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="partition">
                    <h2 class="head2-small"> Step 1: Download the Template </h2>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <div class="bottom-20">

                    <button class="button primary" (click)="downlaodExcelTemplate()">
                        Download License template
                    </button>


                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="partition">
                    <h2 class="head2-small">  Step 2: Upload the Template </h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="upload-wrapper">
                    <div class="choose-file-wrapper wide">
                        <button id="yourBtn" class="button secondary" (click)="getFile()">Choose</button>
                    </div>
                    <div class="file-input-hidden"><input #fileInput id="upfile" type="file" name="file" ng2FileSelect [uploader]="uploader" (change)="sub(this)" /></div>
                    <div class="file-name-sec">
                        <p *ngIf="!FileName">No file choosen</p><p *ngIf="FileName">{{FileName}}</p>
                    </div>

                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-16">
                <div class="bottom-20">

                    <p>Please upload your file in <strong>Excel format only</strong>.</p>

                    <p>Once your file has been uploaded, you’ll immediately receive a list of any errors or missing data that is required. Please fix these errors and upload your file again.</p>

                    <p>NOTE: Once you click upload button system will start processing of input file and result will be shown below for records processed successful and records which got failed.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button id="uplaod" class="button primary" (click)="uploadClick()"  [disabled]="!uploader.getNotUploadedItems().length">Upload</button>
            </div>
        </div>
    </div>
</div>